import React, { useState, useEffect, useRef } from 'react';
import ImageMapper from 'react-img-mapper';
import siteplan from '../../../../../assets/siteplan.jpg';
import getMapCoordinates from '../../../../../api/Siteplan/getMapCoordinates.api';
import getLotCoBroker from '../../../../../api/Siteplan/getLotCoBroker.api';
import { connect } from 'react-redux';
import {
	setLotSelectedId,
	setLotsSelected,
	pushLotsSelected,
	setShowAvailableLots,
	getFitModels,
} from '../../../../../redux/siteplanManagement/action';
import styles from './siteplanImgMapper.module.scss';
import StopRounded from '@material-ui/icons/StopRounded';
import getLotModels from '../../../../../api/Siteplan/getLotModels.api';

const SiteplanImgMapper = (props) => {
	const [imageMapperWidth, setImageMapperWidth] = useState(0);
	const [mapCoords, setMapCoords] = useState({
		name: 'my-map',
	});
	const [hoveredArea, setHoveredArea] = useState();
	const imageMapperRef = useRef();

	const {
		userDetails,
		setLotSelectedId,
		setLotsSelected,
		pushLotsSelected,
		setShowAvailableLots,
		getFitModels,
		stayHighlighted,
	} = props;

	let movement_timer = null;

	useEffect(() => {
		return () => {
			setLotsSelected({});
			setLotSelectedId('');
			setShowAvailableLots(true);
		};
	}, []);

	useEffect(() => {
		setImageMapperWidth(imageMapperRef.current.offsetWidth);
		getMapCoordinates(userDetails, mapCoords, (returned) => {
			setMapCoords(returned);
		});
	}, []);

	window.addEventListener('resize', () => {
		clearTimeout(movement_timer);
		movement_timer = setTimeout(() => {
			if (imageMapperRef.current?.offsetWidth) {
				setImageMapperWidth(imageMapperRef.current.offsetWidth);
			}
		}, 1000);
	});

	const handleClickLot = (area) => {
		getFitModels(area.id);
		setLotSelectedId(area.id);
		pushLotsSelected(area.id);
	};

	const enterArea = (area) => {
		setHoveredArea(area);
		// let lotSelected = area.name;
		// getLotCoBroker(lotSelected, (coBrokerValue) => {
		// 	if (userDetails.userType === 'cobroker') {
		// 		if (userDetails.uid == coBrokerValue) {
		// 			setHoveredArea(area);
		// 		}
		// 	} else {
		// 		setHoveredArea(area);
		// 	}
		// });
	};

	const handleMouseMove = (area, index, event) => {
		return {
			top: `${area.center[1] - 20}px`,
			left: `${area.center[0]}px`,
			fontSize: imageMapperWidth > 750 ? '16px' : '14px',
		};
	};

	const handleMouseLeave = (event) => {
		setHoveredArea();
	};

	return (
		<div ref={imageMapperRef} className={styles.siteplan_img_mapper}>
			<ImageMapper
				src={siteplan}
				map={
					mapCoords?.areas ? mapCoords : { name: 'my-map', areas: [] }
				}
				responsive={true}
				parentWidth={imageMapperWidth}
				stayHighlighted={stayHighlighted}
				fillColor={'rgba(71, 131, 230, 0.70)'}
				strokeColor={'rgba(71, 131, 230)'}
				onClick={(area) => {
					handleClickLot(area);
				}}
				onMouseEnter={(area) => {
					enterArea(area);
					handleMouseMove(area);
				}}
				onMouseLeave={(event) => {
					handleMouseLeave(event);
				}}
			/>

			{hoveredArea && (
				<div
					className={styles.tooltip}
					style={{ ...handleMouseMove(hoveredArea) }}
				>
					{Number.isInteger(hoveredArea?.name * 1) && (
						<span>Lot&nbsp;</span>
					)}
					<span>{hoveredArea.name}</span>
				</div>
			)}
			<div className={styles.legnedWrapper}>
				<div className={styles.legend}>
					<StopRounded className={styles.available} />
					<span>Available</span>
				</div>
				<div className={styles.legend}>
					<StopRounded className={styles.pending} />
					<span>Pending</span>
				</div>
				<div className={styles.legend}>
					<StopRounded className={styles.soldout} />
					<span>Sold Out</span>
				</div>
				<div className={styles.legend}>
					<StopRounded className={styles.hold} />
					<span>Not Available</span>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	userDetails: state.signIn,
});

export default connect(mapStateToProps, {
	setLotSelectedId,
	setLotsSelected,
	pushLotsSelected,
	setShowAvailableLots,
	getFitModels,
})(SiteplanImgMapper);
